import angular from 'angular';

class modalContainerEnableConfirmCtrl {
  /*@ngInject*/
  constructor() {}

  $onInit() {
    this.pathNotExists = angular.copy(this.resolve.pathNotExists);
  }

  cancel() {
    this.modalInstance.dismiss('cancel');
  }

  ok() {
    this.modalInstance.close(true);
  }
}

angular.module('app.principal').component('modalContainerEnableConfirm', {
  templateUrl: require('./modal-container-enable-confirm.html'),
  controller: modalContainerEnableConfirmCtrl,
  bindings: {
    modalInstance: '<',
    resolve: '<'
  }
});
